import { environment, localUrl } from './../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as qs from 'qs';
import { Router } from '@angular/router';
import { User } from './type';
import { CommonService } from '../services/common.service';

export interface HttpCustomConfig {
  needSuccessInfo?: boolean; // 是否需要"操作成功"提示
  showLoading?: boolean; // 是否需要loading
  otherUrl?: boolean; // 是否是第三方接口
}

export interface ActionResult<T> {
  errcode: string;
  msg: string;
  data: T;
  [key: string]: any
}

@Injectable({
  providedIn: 'root'
})
export class BaseHttpService {
  uri: string;
  token: string | null = null;
  username: string | null = null;
  userInfo: User | null = null;
  version = '1.0.1'

  protected constructor(public http: HttpClient, public message: NzMessageService, private router: Router, private commonService: CommonService) {
    this.uri = environment.production ? localUrl : '/api';
  }

  get<T>(path: string, param?: NzSafeAny, config?: HttpCustomConfig): Observable<ActionResult<T>> {
    config = config || { needSuccessInfo: false };
    let reqPath = this.getUrl(path, config);
    const params = new HttpParams({ fromString: qs.stringify(param) });
    return this.http.get<ActionResult<T>>(reqPath, { params, headers: this.getHeaders() }).pipe(this.resultHandle<T>(config));
  }

  delete<T>(path: string, param?: NzSafeAny, config?: HttpCustomConfig): Observable<ActionResult<T>> {
    config = config || { needSuccessInfo: false };
    let reqPath = this.getUrl(path, config);
    const params = new HttpParams({ fromString: qs.stringify(param) });
    return this.http.delete<ActionResult<T>>(reqPath, { params, headers: this.getHeaders() }).pipe(this.resultHandle<T>(config));
  }

  post<T>(path: string, param?: NzSafeAny, config?: HttpCustomConfig): Observable<ActionResult<T>> {
    config = config || { needSuccessInfo: false };
    let reqPath = this.getUrl(path, config);
    return this.http.post<ActionResult<T>>(reqPath, param, { headers: this.getHeaders() }).pipe(this.resultHandle<T>(config));
  }

  put<T>(path: string, param?: NzSafeAny, config?: HttpCustomConfig): Observable<ActionResult<T>> {
    config = config || { needSuccessInfo: false };
    let reqPath = this.getUrl(path, config);
    return this.http.put<ActionResult<T>>(reqPath, param, { headers: this.getHeaders() }).pipe(this.resultHandle<T>(config));
  }

  // 上传
  upload(path: string, file: FormData, reportProgress = true) {
    const req = new HttpRequest('POST', (environment.production ? 'https://hxwebapi.well-healthcare.com:18082/api' : '/api') + path, file, {
      reportProgress,
      headers: this.getHeaders()
    });
    return this.http.request(req).pipe(map((item: any) => {
      if (item?.body?.errcode) {
        if (item?.body?.errcode !== '00000') {
          if (item?.body?.errcode === 'A0340') {
            localStorage.removeItem('meUsername');
            localStorage.removeItem('meToken');
            this.username = null;
            this.token = null;
            this.userInfo = null;
            this.commonService.sendData({ msg: this.commonService.subjectCode.clearInspectionService })
            this.router.navigateByUrl('/login')
          }
          this.message.error(item?.body?.msg)
          console.error(item?.body?.msg);
          return item
          // throw new Error(item.msg);
        }
      }
      return item
    }))
  }

  downLoadWithBlob(path: string, param?: NzSafeAny, config?: HttpCustomConfig): Observable<NzSafeAny> {
    config = config || { needSuccessInfo: false };
    let reqPath = this.getUrl(path, config);
    return this.http.post(reqPath, param, {
      responseType: 'blob',
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    });
  }

  downLoadWithBlobByGet(path: string, param?: NzSafeAny, config?: HttpCustomConfig): Observable<NzSafeAny> {
    config = config || { needSuccessInfo: false };
    let reqPath = this.getUrl(path, config);
    const params = new HttpParams({ fromString: qs.stringify(param) });
    return this.http.get(reqPath, {
      params,
      responseType: 'blob',
      headers: this.getHeaders().append('Content-Type', 'application/json')
    });
  }

  getUrl(path: string, config: HttpCustomConfig): string {
    let reqPath = this.uri + path;
    if (config.otherUrl) {
      reqPath = path;
    }
    return reqPath;
  }

  resultHandle<T>(config: HttpCustomConfig): (observable: Observable<ActionResult<T>>) => Observable<ActionResult<T>> {
    return (observable: Observable<ActionResult<T>>) => {
      return observable.pipe(
        filter(item => {
          return this.handleFilter(item, !!config.needSuccessInfo);
        }),
        map(item => {
          if (item.errcode !== '00000') {
            if (item.errcode === 'A0340') {
              localStorage.removeItem('meUsername');
              localStorage.removeItem('meToken');
              this.username = null;
              this.token = null;
              this.userInfo = null;
              this.commonService.sendData({ msg: this.commonService.subjectCode.clearInspectionService })
              this.router.navigateByUrl('/login')
            }
            console.error(item.msg);
            // throw new Error(item.msg);
          }
          return item;
        })
      ).pipe(catchError(error => this.handleError(error)));
    };
  }


  private handleError(error: HttpErrorResponse): Observable<never> {
    const status = error.status;
    let errMsg = '';
    console.log(error)
    if (status === 0) {
      errMsg = '未知错误，请尝试重新登陆。';
    }
    if (status >= 300 && status < 400) {
      errMsg = `请求被服务器重定向，状态码为${status}`;
    }
    if (status >= 400 && status < 500) {
      errMsg = `客户端出错，可能是发送的数据有误，状态码为${status}`;
    }
    if (status >= 500) {
      errMsg = `服务器发生错误，状态码为${status}`;
    }
    if (errMsg.length) this.message.error(errMsg)
    return throwError(() => {
      return {
        code: status,
        message: errMsg
      };
    });
  }

  handleFilter<T>(item: ActionResult<T>, needSuccessInfo: boolean): boolean {
    if (item.errcode !== '00000') {
      this.message.error(item.msg);
    } else if (needSuccessInfo) {
      this.message.success(item.msg || '操作成功');
    }
    return true;
  }

  getHeaders() {
    if (this.token) {
      return new HttpHeaders({ Authorization: `Bearer<${this.token}>` })
    }
    let meToken = localStorage.getItem('meToken');
    if (meToken) {
      this.token = meToken;
    }
    return new HttpHeaders({ Authorization: `Bearer<${this.token}>` });
  }
}
